import CommonRequesterForm from '../Common/CommonRequesterForm';

const RequesterForm = ({ onSubmit, initialData, requesterData, ws }) => {
    // Use CommonRequesterForm with formType="prepaid"
    return (
        <CommonRequesterForm 
            formType="prepaid" 
            onSubmit={onSubmit}
            initialData={initialData}
            requesterData={requesterData}
            ws={ws}
        />
    );
};

export default RequesterForm;
